import { message, Tooltip } from "antd";
import React, { useState } from "react";
import api, { recordApi } from "../api";
import { CheckCircleOutlined, SyncOutlined } from "@ant-design/icons";

const SyncButton = ({ videoUrls, data }: { videoUrls: any; data: any }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [messageApi, context] = message.useMessage();

  const token = localStorage.getItem("AUTH_TOKEN");

  const handleSyncAdmin = async (id: string) => {
    try {
      setLoading(true);
      const payload = { stream_key: id };
      const response = await recordApi.post(`videos/update-admin`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      messageApi.success(response.data.message);
      window.location.reload();
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const isLive = ["live", "rendering", "in-queue"].includes(data.status);
  const isLiveURL = videoUrls?.[data?.vid]?.includes("stream-kgs");

  return (
    <>
      {context}

      {isLiveURL && !isLive ? (
        <Tooltip title="Not Synced">
          <SyncOutlined
            style={{ color: "red", fontSize: "1.2em", cursor: "pointer" }}
            onClick={() => handleSyncAdmin(data.stream_key)}
          />
        </Tooltip>
      ) : (
        <Tooltip title="Synced">
          <CheckCircleOutlined
            style={{
              color: "green",
              fontSize: "1.2em",
              fontWeight: "bolder",
            }}
          />
        </Tooltip>
      )}
    </>
  );
};

export default SyncButton;
